module.exports = __webpack_public_path__ + "img/camera.d75a88e5.svg";